import "./invoice.css";
import * as React from "react";
import { useState, useEffect } from "react";
import { userRequest } from "../../requestMethods";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { generateFileUrl } from "../../requestMethods";
import {
  formatPricing,
  formatTime24hourFormat,
  formatTimeDDMMYYY,
  formatCpfOrCnpj,
} from "../../util/helper";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import { useCompany } from "../../components/context/CompanyContext";
import { useNavigate } from "react-router-dom";

export default function Invoice() {
  const currentUser = useSelector((state) => state.user.currentUser);
  const location = useLocation();
  const orderId = location.pathname.split("/")[3];
  const [order, setOrder] = useState();
  const [resume, setResume] = useState();
  const [company, setCompany] = useState();
  const [st, setStatus] = useState();
  const { companyId, name, logo, unitProduct } = useCompany();
  const nav = useNavigate();

  useEffect(() => {
    if (companyId > 0) {
      getCompany();
      getOrders();
    }
  }, [companyId]);

  const getCompany = async () => {
    try {
      const res = await userRequest.get(`${companyId}/company`);

      setCompany(res.data);
    } catch (error) {}
  };
  const getOrders = async () => {
    try {
      const res = await userRequest.get(
        `${companyId}/orders/e7619651-a1d9-43c4-ab23-7cac43cf6ded`
      );

      setOrder(res.data);
    } catch (error) {
      console.log("error", error);
    }
  };
  function renderMiniGridHead(sizes) {
    return sizes.map((size) => `<td>${size.label}</td>`).join("");
  }

  function renderMiniGridColorCell(color) {
    return `
    <td style={{"padding: 0; border: none;">
      <div style={{"background-color: ${color.rgb}; height: 35px; padding: 0px; border-radius: 10px;"></div>
      <div style={{"text-align: center; font-size: 10px;">${color.label}</div>
    </td>
  `;
  }

  function renderMiniGridSizeCells(iColor, product) {
    return product.sizes
      .map((size, iSize) => {
        const val = product.colorsSizesGrid[iColor][iSize];
        if (val === undefined || val === null) {
          return `<td class="custom-minigrid-no-value">🚫</td>`;
        }
        return `<td>${val || 0}</td>`;
      })
      .join("");
  }

  function renderMiniGrid(product) {
    const thead = `
    <thead>
      <tr>
        <td>&nbsp;</td>
        ${renderMiniGridHead(product.sizes)}
      </tr>
    </thead>
  `;

    const tbody = product.colors
      .map(
        (color, iColor) => `
    <tr>
      ${renderMiniGridColorCell(color)}
      ${renderMiniGridSizeCells(iColor, product)}
    </tr>
  `
      )
      .join("");

    return `
    <table class="custom-minigrid">
      ${thead}
      <tbody>${tbody}</tbody>
    </table>
  `;
  }
  function renderProductTable(data) {
    if (!data || !data.products) return "";

    const rows = data.products
      .map(
        (product) => `
    <tr style={{"border-bottom: thick double black;">
      <td>
        <img class="custom-item-img" src="${generateFileUrl(product.img)}" />
      </td>
      <td style={{"min-width: 200px;">
        <h4 class="custom_product_title">${product.title}</h4>
        <h5 class="custom_cart_complement">Vlr. unitário: ${formatPricing(
          product.price
        )}</h5>
        <h5 class="custom_cart_complement">Número de ${unitProduct.unitLabel}: ${
          product.quantity
        }</h5>
        <h5 class="custom_cart_complement">Ref.: ${product.ref}</h5>
        <h4 class="custom_product_price">
          Preço: ${formatPricing(product.price * product.quantity)}
        </h4>
      </td>
      <td>
        ${renderMiniGrid(product)}
      </td>
    </tr>
  `
      )
      .join("");

    return `<table class="custon_table">${rows}</table>`;
  }
  function returnAddress(address) {
    let street, cep;
    if (address) {
      street = address.street
        ? address.street
        : "" + "," + address.numAddress
        ? address.numAddress
        : "" + " - " + address.complement
        ? address.complement
        : "";

      cep = address.cep
        ? address.cep
        : "" + " - " + address.city
        ? address.city
        : "" + " - " + address.state
        ? address.state
        : "";
    }
    return `${street}<br/>${cep}`;
  }
  function returnItens(products) {
    let itens = "";

    if (products) {
      products.map(
        (prd) =>
          (itens += (
            <tr>
              <td width="10%" align="left">
                {prd.ref}
              </td>
              <td width="45%" align="left">
                {prd.title}
              </td>
              <td width="10%" align="center">
                {prd.quantity}
              </td>
              <td width="15%" align="center">
                {formatPricing(prd.price)}
              </td>
              <td width="15%" align="center">
                {formatPricing(prd.quantity * prd.price)}
              </td>
            </tr>
          ))
      );
    }
    return itens;
  }
  function getDiscount() {
    let vl = order && order.discount ? order.discount / 100 : 0;

    return order ? order.amount * vl : 0;
  }
  function getTotalOrder() {
    let delivery =
      order && order.delivery?.VlTotal > 0 ? order.delivery?.VlTotal : 0;
    return order && order.amount - getDiscount() + delivery - order.cashback;
  }

  return (
    <div className="invoice-box">
      <div className="divlogoimg">
        <img
          className="logoimg"
          src="https://mooda-poc-space.nyc3.cdn.digitaloceanspaces.com/__poc/1/logo/mooda.png"
          alt="Logo"
        />
      </div>
      <h3 className="labelHead">Comprovante do Pedido</h3>
      <div>
        <span className="negrito">Pedido: </span>
        <span className="spanData">20250701020543</span>
      </div>
      <div>
        <span className="negrito">Criado: </span>
        <span className="spanData">01/07/2025 14:05:43</span>
      </div>
      <div>
        <span className="negrito">Pago: </span>
        <span className="spanData">09/07/2025 09:41:09</span>
      </div>
      <div>
        <span className="negrito">Forma de Pagamento: </span>
        <span className="spanData">VISA (undefined vezes)</span>
      </div>
      <br />
      <div className="negrito">Empresa</div>
      <div className="spanData">Mooda</div>
      <div className="spanData">52.670.859/0001-01</div>
      <div className="spanData">
        RUA PORTO ALEGRE,1 - <br />
        03185-020 - SP - SÃO PAULO
      </div>
      <br />
      <div className="negrito">Cliente</div>
      <div className="spanData">FABIO VAREJO</div>
      <div className="spanData">318.801.378-79</div>
      <div className="spanData">
        RUA MARQUÊS DE VALENÇA,2 - <br />
        03182-040 - SP - SÃO PAULO
      </div>
      <br />
      <table
        style={{ borderCollapse: "collapse", margin: "10px" }}
        className="custon_table"
      >
        <tbody>
          <tr style={{ borderBottom: "thick double black" }}>
            <td>
              <img
                className="custom-item-img"
                src="https://mooda-poc-space.nyc3.cdn.digitaloceanspaces.com/1/2804/P.0058.JPEG/DB9370--undefined"
                alt=""
              />
            </td>
            <td style={{ minWidth: "150px" }}>
              <h4 className="custom_product_title">CALÇA MOM VIVIANE</h4>
              <h5 className="custom_cart_complement">
                Vlr. unitário: R$ 149,90
              </h5>
              <h5 className="custom_cart_complement">Número de {unitProduct.unitLabel}: 1</h5>
              <h5 className="custom_cart_complement">Ref.: P.0058</h5>
              <h4 className="custom_product_price">Preço: R$ 149,90</h4>
            </td>
            <td>
              <table className="custom-minigrid">
                <thead>
                  <tr>
                    <td>&nbsp;</td>
                    <td>34</td>
                    <td>36</td>
                    <td>38</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ padding: 0, border: "none" }}>
                      <div
                        style={{
                          backgroundColor: "#DB9370",
                          height: "35px",
                          padding: "0px",
                          borderRadius: "10px",
                        }}
                      ></div>
                      <div style={{ textAlign: "center", fontSize: "10px" }}>
                        BRONZE
                      </div>
                    </td>
                    <td>1</td>
                    <td>0</td>
                    <td>0</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr style={{ borderBottom: "thick double black" }}>
            <td>
              <img
                className="custom-item-img"
                src="https://mooda-poc-space.nyc3.cdn.digitaloceanspaces.com/1/3009/W.1184.JPEG"
                alt=""
              />
            </td>
            <td style={{ minWidth: "200px" }}>
              <h4 className="custom_product_title">
                CALÇA RETA NUBIA BLUE DENIM
              </h4>
              <h5 className="custom_cart_complement">
                Vlr. unitário: R$ 114,90
              </h5>
              <h5 className="custom_cart_complement">Número de {unitProduct.unitLabel}: 1</h5>
              <h5 className="custom_cart_complement">Ref.: W.1184</h5>
              <h4 className="custom_product_price">Preço: R$ 114,90</h4>
            </td>
            <td>
              <table className="custom-minigrid">
                <thead>
                  <tr>
                    <td>&nbsp;</td>
                    <td>36</td>
                    <td>38</td>
                    <td>40</td>
                    <td>42</td>
                    <td>44</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ padding: 0, border: "none" }}>
                      <div
                        style={{
                          backgroundColor: "#0000FF",
                          height: "35px",
                          padding: "0px",
                          borderRadius: "10px",
                        }}
                      ></div>
                      <div style={{ textAlign: "center", fontSize: "10px" }}>
                        AZUL
                      </div>
                    </td>
                    <td>0</td>
                    <td>1</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>

      <br />
      <div>
        <span className="negrito">Número de {unitProduct.unitLabel}: </span>
        <span className="spanData">2 pc.</span>
      </div>
      <div>
        <span className="negrito">Subtotal: </span>
        <span className="spanData">R$ 264,80</span>
      </div>
      <div>
        <span className="negrito">Frete: </span>
        <span className="spanData">R$ 15,99</span>
      </div>
      <div>
        <span className="negrito">Total </span>
        <span className="spanData">R$ 280,79</span>
      </div>
    </div>
  );
}
